import { render, staticRenderFns } from "./LoyaltyCheckCarrier.vue?vue&type=template&id=2a2e18fe"
import script from "./LoyaltyCheckCarrier.vue?vue&type=script&lang=js"
export * from "./LoyaltyCheckCarrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports